export default __webpack_public_path__ + "static/media/05f65e4f06f13d33472dcf9181634cd21581540291429.b85836d2.webp";